import * as React from "react";
import {FormGroupProps} from "../../../common/props/FormGroupProps";
import {PressableProps} from "../../../common/props/PresableProps";
import {FocusableProps} from "../../../common/props/FocusableProps";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import {option, Option} from "ts-option";
import {PlaceholderProps} from "../../../common/props/PlaceholderProps";
import {ClearableProps} from "../../../common/props/ClearableProps";
import MerchantBranchLocation from "../../../../model/merchant/MerchantBranchLocation";
import SelectPreferredMerchantBranchLocation from "./SelectPreferredMerchantBranchLocation";
import {api} from "../../../../api/api";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import _ = require("underscore");

interface IState {
	merchantBranchLocations: MerchantBranchLocation[],
	isLoading: boolean
}

type Props = FormGroupProps<string> & FocusableProps & PressableProps & PlaceholderProps & ClearableProps;

/**
 * Preferred merchant branch location form view group.
 */
export default class PreferredMerchantBranchLocationSelectorFormGroup extends React.PureComponent <Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {merchantBranchLocations: [], isLoading: false};
		this.onChange = this.onChange.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
	}

	componentDidMount() {
		if (this.props.field.value.isDefined) {
			this.getMerchantBranchLocationById(this.props.field.value.get)
		}
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<SelectPreferredMerchantBranchLocation placeholder={this.props.placeholder}
													   onInputChange={_.debounce(this.onInputChange, 1000, false)}
													   selectedId={this.props.field.value}
													   onChanged={this.onChange}
													   clearable={this.props.clearable}
													   items={option(this.state.merchantBranchLocations)}
													   isLoading={this.state.isLoading}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on merchant branch location selection change
	 * @param {Option<MerchantBranchLocation>} preferredMerchantBranchLocation
	 */
	onChange(preferredMerchantBranchLocation: Option<MerchantBranchLocation>) {
		this.props.onChange(
			this.props.field.updateValue(preferredMerchantBranchLocation.map((pmbl) => pmbl.id))
		);
	}

	/**
	 * Callback on input value change
	 * @param {string} value
	 */
	onInputChange(value: string) {
		if (value.trim() == "") {
			this.setState({merchantBranchLocations: [], isLoading: false})
		}
		else {
			this.getAllMerchantBranchLocationsByName(value)
		}
	}

	/**
	 * Get merchant branch locations by given name
	 * @param {string} value Branch name
	 */
	getAllMerchantBranchLocationsByName(value: string) {
		this.setState({isLoading: true});
		api.instance.merchantApi.getAllMerchantBranchLocationsByName(value).then(
			(pmbl: MerchantBranchLocation[]) => this.setState({merchantBranchLocations: pmbl, isLoading: false})
		).catch(() => this.setState({isLoading: false}))
	}

	/**
	 * Get merchant branch location for given identifier
	 * @param {string} preferredMerchantBranchLocationId
	 */
	getMerchantBranchLocationById(preferredMerchantBranchLocationId: string) {
		this.setState({isLoading: true});
		api.instance.merchantApi.getMerchantBranchLocationById(preferredMerchantBranchLocationId).then(
			(pmbl: MerchantBranchLocation) => this.setState({merchantBranchLocations: [pmbl], isLoading: false})).catch(
			(error) => {
				notifyBugsnagAndShowToast(error, "Merchant branch location");
			})
	}
}